<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/dashboard" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title *ngIf="this.user">{{this.user.userType === userType.Caller ? 'Reservation History' : 'My Services'}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="loadData($event, false)">
    <ion-refresher-content pullingIcon="caret-down" pullingText="Pull to refresh" refreshingSpinner="circles"
      refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>

  <ion-list *ngIf="listHistory.length" class="list-history">
    <ion-card class="ion-margin-top card-history" *ngFor="let item of listHistory; let i = index">
      <ion-card-header>
        <div class="header">
          <h2 class="title">
            <div class="ico">
              <ion-img src="assets/restaurant.png" />
            </div>
            <p>
              {{ item.nomeCliente }}
              <small><ion-icon name="call"></ion-icon> {{ item.celular }}</small>
            </p>
          </h2>
        </div>
      </ion-card-header>

      <div class="card-body">
        <div class="data">
          <ion-item *ngIf="claim === userType.Caller">
            <ion-icon name="restaurant-spread" slot="start"></ion-icon>
            <ion-label>{{ item.restaurante.nome }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="calendar" slot="start"></ion-icon>
            <ion-label>{{ item.dataReservaCliente ? (item.dataReservaCliente | date: "MM/dd/yyyy h:mm a") :
              item.dataReservaFinalizada ?
              (item.dataReservaFinalizada | date: "MM/dd/yyyy h:mm a") + ' - Walk-in' : 'Walk-in' }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="person" slot="start"></ion-icon>
            <ion-label>{{ item.quantidadePessoas }} people</ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="cash" slot="start"></ion-icon>
            <ion-label *ngIf="claim === userType.Caller">{{ (item.vendedor.id === this.user.id ? item.comissaoVendedor :
              item.comissaoVendedorMaster) | currency }}</ion-label>
            <ion-label *ngIf="claim === userType.Restaurant">{{ item.valor | currency }}</ion-label>
            <ion-label *ngIf="item.vendedorMasterId === user.id">Master</ion-label>
          </ion-item>
          <ion-item *ngIf="item.status === 1 && claim === userType.Restaurant && canShowNoShowInfo(item)">
            <ion-icon name="warning" slot="start"></ion-icon>
            <ion-label class="no-show-warning">This reservation will finish in 24 hours</ion-label>
          </ion-item>
          <ion-item *ngIf="item.observation">
            <ion-icon name="chatbubbles" slot="start"></ion-icon>
            <ion-label>{{ item.observation }}</ion-label>
          </ion-item>
          <ion-item>
            <ion-icon name="book" slot="start"></ion-icon>
            <div style="display: flex; flex-direction: column;">
              <ion-label *ngFor="let servico of item.servicos">{{ getServiceDescription(servico) }}</ion-label>
            </div>
          </ion-item>
        </div>

        <div class="flags">
          <ion-img *ngIf="item.idiomas.includes(Languages.English)" src="assets/English.svg" class="icone" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Portuguese)" src="assets/Portuguese.svg" class="icone" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Spanish)" src="assets/Spanish.png" class="icone" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Mandarin)" src="assets/Mandarin.png" class="icone" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.French)" src="assets/French.png" class="icone" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Italian)" src="assets/Italian.png" class="icone" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Japanese)" src="assets/Japanese.png" class="icone" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Arabic)" src="assets/Arabic.png" class="icone" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.German)" src="assets/German.png" class="icone" alt="" />
          <ion-img *ngIf="item.idiomas.includes(Languages.Russian)" src="assets/Russian.png" class="icone" alt="" />
        </div>
      </div>

      <div class="footer">
        <span class="status-badge" [ngClass]="'status-' + getCardColor(item)">
          <ion-icon name="flag"></ion-icon>
          {{ getStatusText(status[item.status]) | titlecase }}
        </span>
        <div class="footer-actions"
          *ngIf="claim === userType.Restaurant || (claim === userType.Caller && item.vendedor.id === this.user.id)">
          <button class="btn-pill btn-secondary" (click)="editReserv(item, i)"
            *ngIf="item.status === 1 && claim === userType.Restaurant">
            Edit
          </button>
          <button *ngIf="item.status === 1 && claim === userType.Restaurant" (click)="finished(item)"
            class="btn-pill btn-go">Finish</button>
          <button *ngIf="item.status === 1 && claim === userType.Restaurant && canShowNoShowInfo(item)"
            (click)="noShow(item)" class="btn-pill btn-danger">No Show</button>
          <button class="btn-pill" (click)="newReservation(item)">
            New Reservation
          </button>
        </div>
      </div>
    </ion-card>
  </ion-list>

  <div class="ion-padding ion-text-center" *ngIf="!listHistory.length">No results found.</div>

</ion-content>
<app-modal-component *ngIf="showModalEdit && reservSelected" (stateOpen)="showModalEdit = $event">
  <h2 class="title">Select the number of people that should be in this reservation</h2>
  <ion-item>
    <ion-label position="floating">Number People</ion-label>
    <ion-input type="number" [(ngModel)]="selectNumber"></ion-input>
  </ion-item>
  <button class="ion-margin-top button-bigger grey" (click)="confirmEdition()">Confirm Edition</button>
</app-modal-component>

<app-modal-component *ngIf="showModalFilter" (stateOpen)="showModalFilter = $event">
  <h3 style="font-weight: normal;">Here you can search for the history of all services by name, period and status.</h3>
  <form [formGroup]="filterForm">
    <ion-item>
      <ion-label position="floating">Client name</ion-label>
      <ion-input type="text" formControlName="nomeCliente"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="floating">Begin date</ion-label>
      <ion-input type="datetime-local" formControlName="dataInicio"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="floating">End date</ion-label>
      <ion-input type="datetime-local" formControlName="dataFim"></ion-input>
    </ion-item>
    <ion-item>
      <ion-label position="floating">Reservation status</ion-label>
      <ion-select formControlName="status">
        <ion-select-option *ngFor="let status of todosStatus" [value]="status.id">
          {{ status.name }}
        </ion-select-option>
      </ion-select>
    </ion-item>
  </form>
  <button class="ion-margin-top button-bigger grey" (click)="filterData(null, true)">Search</button>
</app-modal-component>

<ion-fab vertical="bottom" horizontal="end" slot="fixed" size="small">
  <ion-fab-button *ngIf="!isFiltered" color="primary" (click)="showFilter()">
    <ion-icon name="search"></ion-icon>
  </ion-fab-button>
  <ion-fab-button *ngIf="isFiltered" color="primary" (click)="loadData(null, false)">
    <ion-icon name="close"></ion-icon>
  </ion-fab-button>
</ion-fab>
